import client from '@/services/client'
import type {
  IFlowCriterion,
  IFlowCriterionWithValues,
  ICriterionCreate,
  ICriterionUpdate,
} from '@/types/CriteriaTypes'

import type { AxiosResponse } from 'axios'

const getAll = async (): Promise<AxiosResponse<IFlowCriterionWithValues[]>> => {
  return await client.get<IFlowCriterionWithValues[]>(`flows/criteria`)
}

const get = async (
  criterionUuid: string
): Promise<AxiosResponse<IFlowCriterion>> => {
  return await client.get<IFlowCriterion>(`flows/criteria/${criterionUuid}`)
}

const create = async (
  criterion: ICriterionCreate
): Promise<AxiosResponse<IFlowCriterion>> => {
  return await client.post<IFlowCriterion>(`flows/criteria`, criterion)
}

const update = async (
  criterionUuid: string,
  criterion: ICriterionUpdate
): Promise<AxiosResponse<IFlowCriterion>> => {
  return await client.patch<IFlowCriterion>(
    `flows/criteria/${criterionUuid}`,
    criterion
  )
}

/**
 * Update indexes of criteria, order of uuids matters.
 * All criteria must be provided.
 * @param {Array<string>} criterionUuids
 */
const updateIndexes = async (
  criterionUuids: string[]
): Promise<AxiosResponse<IFlowCriterion[]>> => {
  return await client.put<IFlowCriterion[]>(`flows/criteria/indexes`, {
    criterionUuids,
  })
}

// Soft-deletes the criterion with its values, published flows using it get archived
const destroy = async (criterionUuid: string): Promise<AxiosResponse<void>> => {
  return await client.delete<void>(`flows/criteria/${criterionUuid}`)
}

export const FlowCriteria = {
  getAll,
  get,
  create,
  update,
  updateIndexes,
  destroy,
}
